import axios from "axios";
import store from "@/store";

const laravelApi = axios.create({
  baseURL: process.env.VUE_APP_API_LARAVEL_URL
});

laravelApi.interceptors.request.use(config => {
  const token = (store.state as any).global.authToken;
  if (token) {
    config.headers!.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default laravelApi;
